import apiClient from './axiosClient';

const getLocationFromCoords = (coordinates: [number, number]) => {
  return apiClient
    .get(`places/location/${coordinates.join(',')}`)
    .then((res) => res.data);
};

export default getLocationFromCoords;
